import loadable from '@loadable/component';

export const SalaryReportLoadable = loadable(() => import('./SalaryReport'), {
  resolveComponent: (module) => module.SalaryReportContainerContainer,
});
